import { useEffect, useState } from 'react';

import { default as Candidate } from 'model/Candidate/Candidate';
import { useCurrentUserQuery } from 'shared/legacy/hooks/useCurrentUserQuery';
import { useSendCallMobilePushNotification } from 'shared/legacy/hooks/useSendCallMobilePushNotification';

export const useSendUserNotification = ({
  candidate,
  wasAutomaticallyOpened,
}: {
  candidate: Candidate;
  wasAutomaticallyOpened: boolean;
}) => {
  const { data: currentUser } = useCurrentUserQuery();
  const isMobileAppConnected = !!currentUser?.expo_push_token;
  const [isSent, setIsSent] = useState(false);

  const sendNotification = useSendCallMobilePushNotification();

  useEffect(() => {
    if (isMobileAppConnected && candidate?.not_obfuscated_phone && !wasAutomaticallyOpened && !isSent) {
      sendNotification({
        candidateName: candidate.name,
        candidatePhoneNumber: candidate.not_obfuscated_phone,
      });

      setIsSent(true);
    }
  }, [isMobileAppConnected, candidate?.not_obfuscated_phone, wasAutomaticallyOpened, isSent]);
};
